export const LiveActivityApiColumns = {
    STARTS: 'starts',
    UPDATES_SENT: 'updates_sent',
}
